import axios from "axios";

const TABLET_URLS = {
    development: "https://tablet-api-local.supsis.live/api",
    stage: "https://beta-api.supsis.live/api",
    production: "https://api.supsis.live/api",
};
let apiAddress = TABLET_URLS["development"];

if (window.location.hostname === "form.supsis.ai") {
    apiAddress = TABLET_URLS["production"];
}
if (window.location.href.includes("mode=beta")) {
    apiAddress = TABLET_URLS["stage"];
}
// if (window.location.href.includes("mode=beta")) {
//     apiAddress = TABLET_URLS["stage"];
// }

const service = axios.create({
    baseURL: apiAddress,
    timeout: 20000, // request timeout
});

service.defaults.raxConfig = {
    instance: service,
};

service.interceptors.request.use(
    (config) => {
        config.headers["authorization"] = `Bearer ${localStorage.getItem("token")}`;
        config.headers["site-id"] = localStorage.getItem("siteId");
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default service;
